module.exports = __webpack_public_path__ + "img/logo.0d1ec024.png";